import BulkImportStatus from './BulkImportStatus';

const showProcessedStats = [
  BulkImportStatus.PROCESSING_DATA,
  BulkImportStatus.DATA_PROCESSED,
  BulkImportStatus.EXPIRED,
];

export default showProcessedStats;
